import { useGetResources } from '@hooks/useGetResources';
import { VerktoyInfoState } from '@src/types/launchUserInfoType';
import { erVerktoyTilgjengelig } from '@utils/utils';

import type { Verktoy } from '@src/types/minhelseentities';

import Icon from '@helsenorge/designsystem-react/components/Icon';
import InfoSignFill from '@helsenorge/designsystem-react/components/Icons/InfoSignFill';
import NotificationPanel from '@helsenorge/designsystem-react/components/NotificationPanel';

import { theme as hndsTheme } from '@helsenorge/designsystem-react';
import { isAuthorized } from '@helsenorge/framework-utils/hn-authorize';

import styles from '../../styles/verktoy.module.scss';
import verktoyDetailsStyles from '../../styles/verktoyDetails.module.scss';
import { getVerktoyInfoStates } from '../../utils/launchUtil';

interface Props {
  erLaeringsaktivitet: boolean;
  verktoy: Verktoy;
  showOnDetailsPage?: boolean;
}

const LaunchUserInfo = ({ erLaeringsaktivitet, verktoy, showOnDetailsPage }: Props): React.JSX.Element => {
  const resources = useGetResources();
  const erTilgjengelig = erVerktoyTilgjengelig(verktoy);
  const isAuthorizedUser = isAuthorized();

  const infoStates = getVerktoyInfoStates({
    verktoy,
    erTilgjengelig,
    erLaeringsaktivitet,
    isAuthorizedUser,
  });

  const infotextContainerClassName = showOnDetailsPage
    ? verktoyDetailsStyles.details__infotext_container
    : styles.verktoy__infotext_container;

  const infotextClassName = showOnDetailsPage ? verktoyDetailsStyles.details__infotext : styles.verktoy__infotext;
  const infoIcon = <Icon className={styles.verktoy__infotext_icon} svgIcon={InfoSignFill} color={hndsTheme.palette.blueberry700} />;

  return (
    <>
      {infoStates.includes(VerktoyInfoState.IkkeTilgjengelig) && (
        <div className={styles.verktoy__notification__wrapper}>
          <NotificationPanel
            compactVariant="basic"
            label={resources?.verktoyIkkeTilgjengeligMessage}
            testId="ikke-tilgjengelig-verktoy-alert"
            variant="error"
          />
        </div>
      )}
      <div className={infotextContainerClassName}>
        {infoStates.includes(VerktoyInfoState.ManglendeTilgang) && (
          <span className={infotextClassName}>
            {infoIcon}
            {resources?.verktoyKanIkkeStartesManglendeTilgang}
          </span>
        )}
        {infoStates.includes(VerktoyInfoState.DuMaaLoggePaa) && (
          <span className={infotextClassName}>
            {infoIcon}
            {resources?.verktoyElement_loginMessage}
          </span>
        )}
        {infoStates.includes(VerktoyInfoState.MaaForskrives) && (
          <span className={infotextClassName}>
            {infoIcon}
            {resources?.maForskrivesAvBehandler}
          </span>
        )}
      </div>
    </>
  );
};

export default LaunchUserInfo;
